/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillDetailAdditionalServiceVo
 */
export interface BillDetailAdditionalServiceVo {
    /**
     * ID
     * @type {number}
     * @memberof BillDetailAdditionalServiceVo
     */
    id?: number;
    /**
     * 账单ID
     * @type {number}
     * @memberof BillDetailAdditionalServiceVo
     */
    billId?: number;
    /**
     * 附加服务ID
     * @type {number}
     * @memberof BillDetailAdditionalServiceVo
     */
    additionalServiceId?: number;
    /**
     * 附加服务名称（根据语言环境返回）
     * @type {string}
     * @memberof BillDetailAdditionalServiceVo
     */
    additionalServiceName?: string;
    /**
     * 附加服务编码
     * @type {string}
     * @memberof BillDetailAdditionalServiceVo
     */
    additionalServiceCode?: string;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof BillDetailAdditionalServiceVo
     */
    amount?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillDetailAdditionalServiceVo
     */
    currencyCode?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillDetailAdditionalServiceVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BillDetailAdditionalServiceVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the BillDetailAdditionalServiceVo interface.
 */
export function instanceOfBillDetailAdditionalServiceVo(value: object): value is BillDetailAdditionalServiceVo {
    return true;
}

export function BillDetailAdditionalServiceVoFromJSON(json: any): BillDetailAdditionalServiceVo {
    return BillDetailAdditionalServiceVoFromJSONTyped(json, false);
}

export function BillDetailAdditionalServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailAdditionalServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billId': json['billId'] == null ? undefined : json['billId'],
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'additionalServiceName': json['additionalServiceName'] == null ? undefined : json['additionalServiceName'],
        'additionalServiceCode': json['additionalServiceCode'] == null ? undefined : json['additionalServiceCode'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function BillDetailAdditionalServiceVoToJSON(json: any): BillDetailAdditionalServiceVo {
    return BillDetailAdditionalServiceVoToJSONTyped(json, false);
}

export function BillDetailAdditionalServiceVoToJSONTyped(value?: BillDetailAdditionalServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billId': value['billId'],
        'additionalServiceId': value['additionalServiceId'],
        'additionalServiceName': value['additionalServiceName'],
        'additionalServiceCode': value['additionalServiceCode'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

